import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import Wordmark from "../components/Wordmark";

const BG = "https://images.unsplash.com/photo-1489846986031-7cea03ab8fd0?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4">
      <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[var(--auth-overlay)]" />
      <div className="relative z-10 w-full max-w-md fade-up">
        <Link to="/login" className="mb-8 flex justify-center" data-testid="auth-brand">
          <Wordmark sizeClass="text-4xl" />
        </Link>
        <div className="rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-surface)]/95 p-8 shadow-xl backdrop-blur-xl" data-testid="forgot-form">
          <h1 className="font-head text-3xl tracking-wide text-[var(--text-primary)]">Reset Password</h1>

          {sent ? (
            <div data-testid="forgot-sent">
              <p className="mt-3 text-sm text-[var(--text-secondary)]">
                If an account exists for <span className="font-semibold text-[var(--text-primary)]">{email}</span>, a
                password reset link is on its way. The link expires in 15 minutes.
              </p>
              <Link to="/login"
                className="mt-6 block w-full rounded-[var(--card-radius)] bg-[var(--accent)] py-3 text-center font-bold uppercase tracking-wide text-[var(--accent-contrast)] transition-colors hover:bg-[var(--accent-hover)]"
                data-testid="forgot-back-login">
                Back to Sign In
              </Link>
            </div>
          ) : (
            <form onSubmit={submit}>
              <p className="mt-1 text-sm text-[var(--text-secondary)]">Enter your email and we'll send you a link to set a new password.</p>

              {error && <div className="mt-4 rounded-md border border-[var(--border-accent)] bg-[var(--accent)]/10 px-3 py-2 text-sm text-[var(--accent-hover)]" data-testid="forgot-error">{error}</div>}

              <label className="mt-5 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="mt-1 w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-base)] px-4 py-3 text-[var(--text-primary)] outline-none focus:border-[var(--accent)]"
                data-testid="forgot-email-input" placeholder="you@example.com" />

              <button type="submit" disabled={loading}
                className="mt-6 w-full rounded-[var(--card-radius)] bg-[var(--accent)] py-3 font-bold uppercase tracking-wide text-[var(--accent-contrast)] transition-colors hover:bg-[var(--accent-hover)] disabled:opacity-60"
                data-testid="forgot-submit-button">
                {loading ? "Sending..." : "Send Reset Link"}
              </button>

              <p className="mt-5 text-center text-sm text-[var(--text-secondary)]">
                Remembered it?{" "}
                <Link to="/login" className="font-semibold text-[var(--text-primary)] hover:underline" data-testid="forgot-go-login">Back to Sign In</Link>
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
